import { $$ } from "../utils/dom"

$$('.portfolio-archive__featured-post-keywords').forEach(el => {
    new Typewriter(el, {
        strings: el.innerHTML.replace(/&lt;/g, '<span class="opening-chevron"></span>').replace(/&gt;/g, '<span class="closing-chevron"></span>'),
        autoStart: true,
        loop: true,
        pauseFor: 3500,
    })
})